import { render, staticRenderFns } from "./SetLang.vue?vue&type=template&id=61eb661e&scoped=true&"
import script from "./SetLang.vue?vue&type=script&lang=js&"
export * from "./SetLang.vue?vue&type=script&lang=js&"
import style0 from "./SetLang.vue?vue&type=style&index=0&id=61eb661e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61eb661e",
  null
  
)

export default component.exports